export const mainPages = {
  home: {
    id: "home",
    title: "Home",
    path: "/",
    auth: false,
  },
  needHelp: {
    id: "needHelp",
    title: "Questions les plus fréquentes",
    path: "/besoin-daide",
    auth: false,
  },
  service: {
    id: "maliciousService",
    title: "Nos Services Malins",
    path: "/nos-services-malins",
    auth: false,
  },
  recrutment: {
    id: "recrutement",
    title: "Effia recrute",
    path: "/effia-recrute",
    auth: false,
  },
  about: {
    id: "about",
    title: "EFFIA, Déplacez-vous malin !",
    path: "/qui-sommes-nous/effia-deplacez-vous-malin",
    auth: false,
  },
  expertise: {
    id: "expertise",
    title: "Notre expertise sur voirie",
    path: "/qui-sommes-nous/notre-expertise-sur-voirie",
    auth: false,
  },
  legalMentions: {
    id: "legalMentions",
    title: "",
    path: "/cgu-cgv-mentions-legales",
    auth: false,
  },
  roi: {
    id: "roi",
    title: "",
    path: "/reglement-ordre-interieur",
    auth: false,
  },
  cityPage: {
    id: "cityPage",
    title: "",
    path: "/ville/:city",
    auth: false,
  },
  cityPageNL: {
    id: "cityPageNL",
    title: "",
    path: "/stad/:city",
    auth: false,
  },
};

export const passwordModals = {
  resetPassword: {
    id: "resetPassword",
    title: "Reset password",
    path: "/reset-password/",
    auth: false,
  },
  passwordUpdate: {
    id: "passwordUpdate",
    title: "",
    path: "/password-update/:token?",
    auth: false,
  },
};

export const reservationModals = {
  partnerArchivedReservations: {
    id: "partnerArchivedReservations",
    title: "",
    path: "/partner-archived-reservations",
    auth: true,
  },
  partnerCreateReservations: {
    id: "partnerCreateReservations",
    title: "",
    path: "/partner-create-reservations",
    auth: true,
  },
  partnerUpdateReservations: {
    id: "partnerUpdateReservations",
    title: "",
    path: "/partner-update-reservations",
    auth: true,
  },
  partnerDetailsReservation: {
    id: "partnerDetailsReservation",
    title: "",
    path: "/partner-reservation-details",
    auth: true,
  },
  uclArchivedReservations: {
    id: "uclArchivedReservations",
    title: "",
    path: "/ucl-archived-reservations",
    auth: true,
  },
  partnerUpdateReservation: {
    id: "partnerUpdateReservation",
    title: "",
    path: "/partner-update-reservation",
    auth: true,
  },
};

export const parkingModals = {
  parkingService: {
    id: "parkingService",
    title: "Notre savoir-faire parking",
    path: "/qui-sommes-nous/notre-savoir-faire-parking",
    auth: false,
  },
  parkingReservation: {
    id: "parkingReservation",
    title: "Réservez votre place de parking",
    path: "/besoin-daide/reservez-votre-place-de-parking",
    auth: false,
  },
  parkingSubscription: {
    id: "parkingSubscribtion",
    title: "Souscrivez un abonnement",
    path: "parking/:parkingName/recherche/",
    auth: false,
    noAccess: ["partner"],
  },
  parkingSubscriptionNL: {
    id: "parkingSubscribtionNL",
    title: "Souscrivez un abonnement",
    path: "parking/:parkingName/zoeken/",
    auth: false,
    noAccess: ["partner"],
  },
  parkingList: {
    id: "parkingList",
    title: "Liste parkings",
    path: "parkings/recherche/:city",
    auth: false,
  },
  parkingListNL: {
    id: "parkingListNL",
    title: "Liste parkings",
    path: "parkings/zoeken/:city",
    auth: false,
  },
  parkingReservationSub: {
    id: "parkingReservationSub",
    title: "",
    path: "/reservez-votre-place-ou-souscrivez-un-abonnement-dans-le-parking-qui-vous-convient",
    auth: false,
  },
  reservationConfirmation: {
    id: "reservationConfirmation",
    title: "",
    path: "/reservation-confirmation",
    auth: true,
    noAccess: ["partner"],
  },
  ldReservationConfirmation: {
    id: "LongDurationReservationConfirmation",
    title: "",
    path: "/ld-reservation-confirmation",
    auth: true,
    noAcess: ["partner"],
  },
};

export const subscriptionModals = {
  subscription: {
    id: "subscription",
    title: "Souscrivez un abonnement",
    path: "/besoin-daide/souscrivez-un-abonnement",
    auth: false,
  },
  subscriptionConfirmation: {
    id: "subscriptionConfirmation",
    title: "",
    path: "/subscription-confirmation/",
    auth: true,
    noAccess: ["partner"],
  },
  partnerArchivedSubscriptions: {
    id: "partnerArchivedSubscriptions",
    title: "",
    path: "/partner-archived-subscriptions",
    auth: true,
  },
  partnerCreateSubscription: {
    id: "partnerCreateSubscription",
    title: "",
    path: "/partner-create-subscriptions",
    auth: true,
  },
  partnerUpdateSubscription: {
    id: "partnerUpdateSubscription",
    title: "",
    path: "/partner-update-subscription",
    auth: true,
  },
  uclArchivedSubscriptions: {
    id: "uclArchivedSubscriptions",
    title: "",
    path: "/ucl-archived-subscriptions",
    auth: true,
  },
  partnerUpdateSubscriptions: {
    id: "partnerUpdateSubscriptions",
    title: "",
    path: "/partner-update-subscriptions",
    auth: true,
  },
  partnerSubscriptionDetails: {
    id: "partnerSubscriptionDetails",
    title: "",
    path: "/partner-subscription-details",
    auth: true,
  },
};
export const subscriptionPaymentModals = {
  subscriptionPayment: {
    id: "subscriptionPayement",
    title: "",
    path: "/subscription-payement",
    auth: true,
    noAccess: ["partner"],
  },
  paymentRedirection: {
    id: "payementRedirection",
    title: "",
    path: "/payment-return",
    auth: true,
  },
};

export const paymentModals = {
  paymentRedirection: {
    id: "paymentModalRedirection",
    title: "Redirect Status",
    path: "/redirect-status/:id?",
    auth: true,
  },
};

export const profileModals = {
  profile: {
    id: "profile",
    title: "",
    path: "/profile",
    auth: true,
  },
  editProfile: {
    id: "editProfile",
    title: "",
    path: "/edit-profile",
    auth: true,
  },
  verifyProfile: {
    id: "verifyProfile",
    title: "verify",
    path: "/verify-account/",
    auth: false,
  },
};

export const testPages = {
  loading: {
    id: "loading",
    title: "loading",
    path: "loading",
    auth: false,
  },
};
